export default __webpack_public_path__ + "static/media/gallery_02.5fcf2033.jpg";